import { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Container, Grid } from "@mui/material";
import { LocaleContext } from "../../routing/LangRouter";
import axios from "axios";
import BASE_URL from "../../constants/baseUrls";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import useUserInfo from "../../hooks/useUserInfo";

//import utils
import { navigateToLoginPage } from "../../utils/utility";

//import constants
import { IS_MOBILE } from "../../constants/breakpoints";

//import general components
import MobileHeader from "../../components/common/mobile-header/mobile-header";

//import view components
import PanelMenu from "../../components/view/user-panel/panel-menu/panel-menu";
import UserInformation from "../../components/view/user-panel/user-account/user-information";

//import styles
import "./user-panel.scss";

function UserPanel() {
    //genral
    const navigate = useNavigate();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");

    //handle menu change and header title
    const label = {
        [`/${locale}/user-panel/user-account`]: t("userAccount"),
        [`/${locale}/user-panel/orders`]: t("User Panel.myOrders"),
        [`/${locale}/user-panel/friends-introduction`]: t("friendsIntroduction"),
        [`/${locale}/user-panel/my-itinerary`]: t("myItineraries"),
        [`/${locale}/user-panel/passenger`]: t("myFellowTravelers"),
        [`/${locale}/user-panel/wallet`]: t("wallet"),
        [`/${locale}/user-panel/user-favorites`]: t("favorites"),
        [`/${locale}/user-panel/support`]: t("support"),
        [`/${locale}/user-panel/delete-account`]: t("deleteAccount"),
    };

    const [panelState, setPanelState] = useState({
        mobilePanelMenu: true,
        headerTitle: "",
    });

    useEffect(() => {
        setPanelState({
            mobilePanelMenu: location.pathname === `/${locale}/user-panel`,
            headerTitle: location.pathname === `/${locale}/user-panel` ? "" : label[location.pathname],
        });
    }, [location.pathname]);

    //handle back button
    const goToBack = () => {
        if (location.pathname === `/${locale}/user-panel`) {
            navigate(`/${locale}`, { replace: true });
        } else {
            navigate(`/${locale}/user-panel`, { replace: true });
        }
    };

    //request to get user information
    const { userInformation, getUserInfo } = useUserInfo();

    useEffect(() => {
        const init = async () => {
            if (IS_MOBILE && accessToken) {
                await getUserInfo();
            }
        };

        init();
    }, []);

    const [profileError, setProfileError] = useState(false);
    const submitProfileImage = async file => {
        setProfileError(false);
        let data = new FormData();
        data.append("avatar", file);
        try {
            await axios.patch(`${BASE_URL}/api/v2/account/user/info/`, data, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
        } catch (error) {
            setProfileError(true);
            if (error.response.status === 401) {
                localStorage.clear();
                navigateToLoginPage(navigate, locale, location);
            } else {
                toast.error(t("Toast Messages.Image Size Limit Exceeded"), { toastId: "custom-id-yes" });
            }
        }
    };

    return (
        <Grid className="user-panel" container item xs={12} my={{ xs: 5, md: 1 }}>
            <MobileHeader title={panelState?.headerTitle || t("User Panel.Profile")} justifyContent="center" handleClick={goToBack} />

            {IS_MOBILE ? (
                <Grid container columnGap={3} justifyContent="space-between" alignItems="flex-start">
                    {panelState?.mobilePanelMenu ? (
                        <Container maxWidth="xl">
                            <Grid container item xs={12} lg={2}>
                                <UserInformation information={userInformation} onSubmitImage={submitProfileImage} profileError={profileError} />
                            </Grid>
                            <Grid container item xs={12} lg={2}>
                                <PanelMenu />
                            </Grid>
                        </Container>
                    ) : (
                        <Grid container item xs={12} lg={9.5}>
                            <Container maxWidth="xl">
                                <Outlet />
                            </Container>
                        </Grid>
                    )}
                </Grid>
            ) : (
                <Container maxWidth="xl">
                    <Grid container columnGap={3} justifyContent="space-between" alignItems="flex-start">
                        <PanelMenu />

                        <Grid container item xs={12} lg={9.5}>
                            <Outlet />
                        </Grid>
                    </Grid>
                </Container>
            )}
        </Grid>
    );
}
export default UserPanel;
